import { findAuthedAPIList,findAPIList,findGroupList } from '@/service/api';
import { IAPIGroup, IAPIManageState, IAPITable } from "@/typings/apiManage";
import { Module } from "vuex";
import { IGlobalState } from "..";
import * as Types from '../action-types';

const state: IAPIManageState = {
    keyWord: "",
    examineState:-1,
    groups: [],
    apis: {
        page: 1,
        limit: 10,
        page_count: 0,
        total_rows: 0,
        rows:  []
    },
    modalAPI:{
        keyWord: "", 
        groupId: "", 
        apis: {
            page: 1,
            limit: 5,
            page_count: 0,
            total_rows: 0,
            rows:  []
        }
    }
   
};

const apiManage: Module<IAPIManageState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_APPLICATION_AUTHED_API_LIST](state, payload: IAPITable){
            state.apis.rows= payload.rows;
            state.apis.page_count= payload.page_count;
            state.apis.total_rows= payload.total_rows;

        },
        [Types.SET_APPLICATION_AUTHED_API_PAGE](state, payload) {
            state.apis.page = payload;
        },
        [Types.SET_APPLICATION_API_LIST](state, payload: IAPITable) {
            state.modalAPI.apis.rows = payload.rows;
            state.modalAPI.apis.page_count = payload.page_count;
            state.modalAPI.apis.total_rows = payload.total_rows;
        },
        [Types.SET_APPLICATION_API_GROUP_LIST](state, payload: IAPIGroup []) {
            state.groups = payload;
        }
    },
    actions: {
         // 设置应用下已申请API列表
         async [Types.SET_APPLICATION_AUTHED_API_LIST]({ commit }, params) {
            let result = await findAuthedAPIList(params);
            commit(Types.SET_APPLICATION_AUTHED_API_LIST, result.data);
        },
        // 设置申请API弹框API列表
        async [Types.SET_APPLICATION_API_LIST]({ commit }, params) {
            let result = await findAPIList(params);
            commit(Types.SET_APPLICATION_API_LIST, result.data);
        },
         // 设置分组列表
         async [Types.SET_APPLICATION_API_GROUP_LIST]({ commit }, params) {
            let result = await findGroupList(params);
            commit(Types.SET_APPLICATION_API_GROUP_LIST, result.data);
        }
    }
};
export default apiManage;